import {useEffect} from 'react';
import {connect} from 'react-redux';

import {gettext, interpolate} from 'topmeteo/utils/i18n';

import {getLocation} from 'topmeteo/loc/selectors';

const TitleTemplate = gettext('Location Forecast for %s | TopMeteo');

const PageTitle = ({name}) => {
    useEffect(
        () => {
            const {title} = document;

            document.title = interpolate(TitleTemplate, [name], false);

            return () => {
                document.title = title;
            };
        },
        [name],
    );

    return null;
};

const mapStateToProps = state => getLocation(state);

export default connect(mapStateToProps)(PageTitle);
